import React from "react";
import { useNavigate } from "react-router-dom";
import "./WbbHomepage.css";

function WbbHomepage({ pageData }) {
 const navigate = useNavigate();

 const organization = pageData?.organization || {};
 const page = pageData?.page || {};
 const settings = pageData?.settings || {};
 const content = page?.content || {};

 const name = organization.name || "SFPickupWBB";


 const heroEyebrow =
  content.hero_eyebrow || "";

 const heroTitle =
  content.hero_title || name;

 const heroSubtitle =
  content.hero_subtitle ||
  "Competition, community, and women’s basketball in San Francisco.";

 const heroButtonLabel =
  content.hero_button_label || "REGISTER NOW";

 const heroButtonLink =
  content.hero_button_link || "";
 const logoImage =
  content.logo_image_url || "";
 const heroImage =
  content.hero_image_url || "";

 const tournamentSectionTitle =
  content.tournament_section_title || "Tournament Details";

 const tournamentSectionSubtitle =
  content.tournament_section_subtitle ||
  "Everything you need to know before game day.";

 const tournamentDate =
  content.tournament_date || "August 29";

 const tournamentPrice =
  content.tournament_price || "$80 / Player";

 const tournamentFormat =
  content.tournament_format || "5 vs. 5 Full Court";

 const tournamentGames =
  content.tournament_games || "3–5 Games Per Team";

 const tournamentLocation =
  content.tournament_location || "UCSF";

 const handleLinkClick = (rawLink) => {
  const link = String(rawLink || "").trim();

  if (!link) return;

  const isExternal =
   link.startsWith("http://") ||
   link.startsWith("https://");

  const looksLikeDomain =
   !link.startsWith("/") &&
   link.includes(".") &&
   !link.startsWith("./") &&
   !link.startsWith("../");

  if (isExternal) {
   window.open(link, "_blank", "noopener,noreferrer");
   return;
  }

  if (looksLikeDomain) {
   window.open(`https://${link}`, "_blank", "noopener,noreferrer");
   return;
  }

  navigate(link.startsWith("/") ? link : `/${link}`);
 };

 return (
  <div className="wbb-homepage">
   <section
    className="wbb-homepage-hero"
    style={
     heroImage
      ? { backgroundImage: `url(${heroImage})` }
      : undefined
    }
   >
    <div className="wbb-homepage-hero-overlay" />

    <div className="wbb-homepage-hero-content">
     {logoImage && (
      <img
       src={logoImage}
       alt={name}
       className="wbb-homepage-hero-logo"
      />
     )}
     <p className="wbb-homepage-hero-eyebrow">
      {heroEyebrow}
     </p>

     <h1>{heroTitle}</h1>

     <p className="wbb-homepage-hero-subtitle">
      {heroSubtitle}
     </p>

     {heroButtonLink ? (
      <button
       type="button"
       className="wbb-homepage-primary-button"
       onClick={() => handleLinkClick(heroButtonLink)}
      >
       {heroButtonLabel}
      </button>
     ) : null}
    </div>
   </section>

   <section className="wbb-homepage-details-section">
    <div className="wbb-homepage-section-heading">
     <p className="wbb-homepage-section-label">
      Upcoming Event
     </p>

     <h2>{tournamentSectionTitle}</h2>

     <p>{tournamentSectionSubtitle}</p>
    </div>

    <div className="wbb-homepage-details-grid">
     <div className="wbb-homepage-detail-card">
      <span>Date</span>
      <strong>{tournamentDate}</strong>
     </div>

     <div className="wbb-homepage-detail-card">
      <span>Entry</span>
      <strong>{tournamentPrice}</strong>
     </div>

     <div className="wbb-homepage-detail-card">
      <span>Format</span>
      <strong>{tournamentFormat}</strong>
     </div>

     <div className="wbb-homepage-detail-card">
      <span>Games</span>
      <strong>{tournamentGames}</strong>
     </div>

     <div className="wbb-homepage-detail-card">
      <span>Location</span>
      <strong>{tournamentLocation}</strong>
     </div>
    </div>
   </section>
  </div>
 );
}

export default WbbHomepage;